import Lottie from 'lottie-react';
import loadingAnimationData from './loading-animation-data.json';

export const LoadingAnimation = ({
  animationEnabled = true,
}: {
  animationEnabled?: boolean;
}) => {
  return (
    <div className="w-[300px] transform -translate-y-[80px] flex items-center justify-center">
      <Lottie
        animationData={loadingAnimationData}
        loop={animationEnabled}
        autoplay={animationEnabled}
      />
    </div>
  );
};
